import * as React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import moment from 'moment-mini'

import './styles.sass'
import { SingleNotificationInList } from '../../store/member/memberTypings'
import { Link } from 'react-router-dom'
import paths from '../../paths'
import { createLocalizedPath } from '../../utils/localizationHelpers'
import { useEffect, useRef, useState } from 'react'

interface Props {
    notification: SingleNotificationInList
    setReadNotifications: React.Dispatch<string[]>
}

const Notification: React.FunctionComponent<Props> = ({ notification, setReadNotifications }: Props) => {
    const [t] = useTranslation()

    const [isNotificationSeen, setIsNotificationSeen] = useState(false)
    const notificationRef = useRef(null)

    useEffect(() => {
        if (!notification.is_read) {
            if (window && 'IntersectionObserver' in window) {
                // @ts-ignore
                const callback = (entries, observer) => {
                    if (entries[0].isIntersecting) {
                        observer.unobserve(entries[0].target)
                        setTimeout(() => setIsNotificationSeen(true), 30000)
                        // @ts-ignore
                        setReadNotifications((prev) => prev.concat(notification.id))
                    }
                }

                const observer = new IntersectionObserver(callback)

                observer.observe(notificationRef.current)
            } else {
                setTimeout(() => setIsNotificationSeen(true), 30000)
                // @ts-ignore
                setReadNotifications((prev) => prev.concat(notification.id))
            }
        }
    }, [])

    const className =
        notification.is_read || isNotificationSeen
            ? 'notification__body'
            : 'notification__body notification__body_unread'

    return (
        <div className="notification" ref={notificationRef}>
            <div className="notification__date">{moment(notification.date * 1000).format('DD.MM.YYYY - HH:mm')}</div>
            <div className={className}>
                <Link
                    to={
                        notification.meta
                            ? createLocalizedPath(paths.profile.toPath({ nick: notification.meta.user.nick }))
                            : createLocalizedPath(paths.profiles.path)
                    }
                    className="notification__from"
                >
                    {notification.meta ? notification.meta.user.nick : 'anonymous'}
                </Link>

                {(notification.type === 'followee_ephemeral' || notification.type === 'ephemeral') && (
                    <>
                        <Trans i18nKey={'posted a new ephemeral post'}>
                            <div className="notification__text">posted a new </div>
                            <Link to={createLocalizedPath(notification.meta.url)} className="notification__material">
                                ephemeral post
                            </Link>
                        </Trans>
                    </>
                )}

                {notification.type === 'ephemeral_comment' && (
                    <>
                        <Trans i18nKey={'replied to you in ephemeral stories'}>
                            <div className="notification__text">replied to you in </div>
                            <Link to={createLocalizedPath(notification.meta.url)} className="notification__material">
                                Ephemeral stories
                            </Link>
                        </Trans>
                    </>
                )}

                {/*{notification.type === 'ephemeral' && (*/}
                {/*    <>*/}
                {/*        <Trans i18nKey={'posted a new ephemeral post'}>*/}
                {/*            <div className="notification__text">posted a new </div>*/}
                {/*            <Link*/}
                {/*                to={createLocalizedPath(paths.ephemeralPhotos.path)}*/}
                {/*                className="notification__material"*/}
                {/*            >*/}
                {/*                ephemeral post*/}
                {/*            </Link>*/}
                {/*        </Trans>*/}
                {/*    </>*/}
                {/*)}*/}

                {notification.type === 'gift' && (
                    <>
                        <Trans i18nKey={'sent you a gift notification'}>
                            <div className="notification__text">sent you a </div>
                            <Link
                                to={createLocalizedPath(paths.myVirtualGifts.path)}
                                className="notification__material"
                            >
                                gift
                            </Link>
                        </Trans>
                    </>
                )}
                {notification.type === 'guestbook' && (
                    <>
                        <div className="notification__text">{t('sent you a')}</div>
                        <Link to={createLocalizedPath(paths.myGuestbook.path)} className="notification__material">
                            {t('guestbook message')}
                        </Link>
                    </>
                )}
                {notification.type === 'followee_contribution' && (
                    <>
                        <div className="notification__text">{t('upload a new')}</div>
                        <Link to={createLocalizedPath(notification.meta.url)} className="notification__material">
                            {t('contribution')}
                        </Link>
                    </>
                )}
                {notification.type === 'membership_gift' && (
                    <>
                        <Trans
                            i18nKey={'Premium gifted list'}
                            values={{
                                amount: notification.meta.duration
                            }}
                        >
                            <div className="notification__text">gave you</div>
                            <Link
                                to={createLocalizedPath(paths.premiumHistory.path)}
                                className="notification__material"
                            >
                                60 days of Premium
                            </Link>
                        </Trans>
                    </>
                )}
                {notification.type === 'follower' && (
                    <div className="notification__text">{t('starts following you')}</div>
                )}
            </div>
        </div>
    )
}

export default Notification
